<ng-container #contactBodyContainer></ng-container>
<shrd-uic-preloader [active]="isLoading$ | async" immediate></shrd-uic-preloader>
